import React, { useState } from "react";
import momoLogo from '../../assets/MTN_Mobile_Money.jpg'
import omLogo from '../../assets/Orange money.png'

import './Payment.css';

const Payment = ({ onClose, handleSubmit, amounts }) => {
    const [number, setNumber] = useState('');
    const [medium, setMedium] = useState('mobile money');

    const isActiveMomo = medium === 'mobile money';
    const isActiveOm = medium === 'orange money';
    // const [amount] = useState('2');
    const [loading, setLoading] = useState(false);  
    const [error, setError] = useState(null);
    const [paymentRequestSent, setPaymentRequestSent] = useState(false);


    const handleChange = (event) => {
        const value = event.target.value;
        if (/^\d*$/.test(value)) {
            setNumber(value);
        }
    };



const submitRequest = async() => {
    try {
        setLoading(true);
        setError(null);
        setPaymentRequestSent(true);
        
        // Wait 3 seconds so user sees the "Payment request sent" message
        await new Promise(resolve => setTimeout(resolve, 3000));
        
        await handleSubmit(number, medium, 'booking');

        setLoading(false);
    } catch (error) {
        console.log('Error: ', error);
        setLoading(false);
        setPaymentRequestSent(false);
    }
}



    return (
        <div className="payment-overlay">
            <div className="payment-modal">
                <div className="payment-header">
                    <h2>Complete Your Booking</h2>
                    <button className="close-btn" onClick={onClose} aria-label="Close">
                        <i className="fa fa-times" />
                    </button>
                </div>
                
                <div className="payment-content">
                    <div className="payment-amount">
                        <span className="amount-label">Total Amount</span>
                        <span className="amount-value">XAF {amounts}.00</span>
                    </div>
                    
                    <div className="payment-methods">
                        <p className="methods-label">Select Payment Method</p>
                        <div className="method-logos">
                            
                            <div className={`method-logo ${isActiveMomo ? 'active' : ''}`} onClick={() => setMedium('mobile money')}>
                                <img src={momoLogo} alt="MTN Mobile Money" />
                                <span>MTN MoMo</span>
                            </div>
                            <div className={`method-logo ${isActiveOm ? 'active' : ''}`} onClick={() =>setMedium('orange money')}>
                                <img src={omLogo} alt="Orange Money" />
                                <span>Orange Money</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="payment-form">
                        <div className="input-group">
                            <label htmlFor="phone">Phone Number</label>
                            <div className="input-prefix">
                                <span>+237</span>
                                <input 
                                    type="text"
                                    id="phone"
                                    name="number"
                                    value={number}
                                    onChange={handleChange}
                                    placeholder="6XX XXX XXX"
                                    maxLength="9"
                                />
                            </div>
                        </div>
                        
                        <button 
                            className="pay-btn" 
                            onClick={submitRequest} 
                            disabled={loading || number.length !== 9}
                        >
                            {loading ? (
                                <>
                                    <div className="spinner"></div>
                                    Processing Payment...
                                </>
                            ) : (
                                `Pay XAF ${amounts}.00`
                            )}
                        </button>
                        
                        {paymentRequestSent && (
                            <div className="payment-instruction">
                                <div className="instruction-icon"><i className="fa fa-lightbulb-o" /></div>
                                <p>Payment request sent! Please confirm with your PIN code or dial *126# to complete the transaction.</p>
                            </div>
                        )}
                        
                        {error && (
                            <div className="error-message">
                                <div className="error-icon"><i className="fa fa-exclamation-triangle" /></div>
                                <p>{error}</p>
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="payment-footer">
                    <p>Your payment is secure and encrypted</p>
                </div>
            </div>
        </div>
    );
}

export default Payment;
